'use client'

import React from 'react'

import { Box } from '@chakra-ui/react'

import { tableHeaderStyles } from './Table.styles'
import {
  useTableColorScheme,
  useTableDensity,
  useTableVariant,
} from './TableContext'

export type TableHeaderProps = {
  children: React.ReactNode
}

export const TableHeader = ({ children }: TableHeaderProps) => {
  const colorScheme = useTableColorScheme()
  const density = useTableDensity()
  const variant = useTableVariant()
  return (
    <Box {...tableHeaderStyles(colorScheme, density, variant)}>{children}</Box>
  )
}
